<template>
  <div>
    <v-btn-toggle
      class="fill-width rounded-0"
      color="primary"
      background-color="white"
      active-class="selected-button"
      v-model="search.operationType"
      mandatory
    >
      <v-btn value="rent" class="grow" style="background-color: white">
        Alquilar
      </v-btn>

      <v-btn value="sell" class="grow" style="background-color: white">
        Comprar
      </v-btn>

      <v-btn disabled class="grow" style="background-color: white">
        Vender
      </v-btn>
    </v-btn-toggle>

    <v-card
      max-width="800"
      flat
      outlined
      color="background"
      class="mx-auto fill-width rounded-xl rounded-t-0"
    >
      <v-card-text>
        <div class="mt-3 d-flex flex-column flex-md-row">
          <v-autocomplete
            label="Tipo de propiedad"
            v-model="search.propertyType"
            :items="propertyTypes"
            outlined
            mandatory
            auto-select-first
            class="rounded-0 pt-2 shrink"
            style="margin-right: -1px"
            :style="$vuetify.breakpoint.mdAndUp ? 'max-width: 200px' : ''"
            hide-details
            multiple
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span>{{ item.text }}</span>
              </v-chip>
              <span v-if="index === 1" class="grey--text text-caption">
                (+{{ search.propertyType.length - 1 }})
              </span>
            </template>
          </v-autocomplete>
          <v-autocomplete
            label="Buscar dirección"
            :items="cities"
            v-model="search.address"
            outlined
            class="rounded-0 pt-2 grow"
            prepend-inner-icon="mdi-magnify"
            hide-details
          ></v-autocomplete>
        </div>

        <v-dialog
          v-model="advanced"
          width="600"
          :fullscreen="$vuetify.breakpoint.mobile"
        >
          <v-card>
            <v-card-title>
              Filtros avanzados
            </v-card-title>
            <v-divider
              class="mx-6 primary"
              style="width: 72px; border-width: revert"
            ></v-divider>
            <v-card-text class="pb-0">
              <v-row class="my-3">
                <v-col cols="2" class="pr-0">
                  <v-autocomplete
                    :items="currencies"
                    label="Moneda"
                    v-model="search['currency']"
                    outlined
                    dense
                    class="rounded-0"
                    hide-details
                  ></v-autocomplete>
                </v-col>
                <template v-for="(filter, i) in advancedFilters">
                  <v-col
                    :cols="['minPrice'].includes(filter) ? 4 : 6"
                    :class="i % 2 ? '' : 'pr-0'"
                  >
                    <v-text-field
                      :label="$t('filters.' + filter)"
                      v-model="search[filter]"
                      outlined
                      type="number"
                      dense
                      class="rounded-0"
                      hide-details
                    ></v-text-field>
                  </v-col>
                </template>
              </v-row>
            </v-card-text>

            <v-card-actions class="px-6">
              <v-spacer></v-spacer>

              <v-btn color="primary" @click="advanced = false" depressed>
                Guardar cambios
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div class="mt-3 text-center">
          <v-btn
            small
            depressed
            color="secondary"
            @click="advanced = !advanced"
          >
            Filtros avanzados
          </v-btn>
        </div>

        <div class="text-right mt-3">
          <v-btn class="py-5" depressed color="primary" @click="perform">
            {{ adminRoute ? "Guardar" : "Buscar" }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { PropertyTypes } from "@/graphql/queries/properties";

export default {
  data: () => ({
    dialog: false,
    advanced: false,
    cities: ["Reconquista, Santa Fe", "Avellaneda, Santa Fe"],
    propertyTypes: [],
    currencies: ["ARS", "USD"],
    search: {
      operationType: "rent",
      address: null,
      propertyType: [],
      currency: "ARS",
      maxPrice: null,
      minPrice: null,
      maxBrooms: null,
      minBrooms: null,
      maxBaths: null,
      minBaths: null,
      minSurface: null,
      maxSurface: null,
      minCoveredSurface: null,
      maxCoveredSurface: null
    },
    advancedFilters: [
      "minPrice",
      "maxPrice",
      "minBrooms",
      "maxBrooms",
      "minBaths",
      "maxBaths",
      "minSurface",
      "maxSurface",
      "minCoveredSurface",
      "maxCoveredSurface"
    ]
  }),

  created() {
    this.fetchTypes();
  },

  computed: {
    adminRoute() {
      return this.$route.name == "admin_user_detail";
    }
  },

  methods: {
    perform() {
      this.$emit("save", this.search);
    },

    fetchTypes() {
      this.$apollo
        .query({
          query: PropertyTypes,
          variables: {
            agencyIds: [1, 2]
          }
        })
        .then(res => {
          res.data.propertyTypes.forEach(type => {
            this.propertyTypes.push({
              text: this.$t("property.type." + type.name),
              value: type.name
            });
          });
        });
    }
  }
};
</script>
